export default ".msgMain {\n  font-weight: 600;\n  font-size: 1.4em;\n}"